import * as React from 'react';
import * as classNames from 'classnames/bind';

import styles from './SectionTitle.scss';

const cx = classNames.bind(styles);

interface SectionTitleProps {
  theme?: 'light' | 'secondary' | 'secondaryOnDarkBg';
}

const SectionTitle: React.SFC<SectionTitleProps> = ({ children, theme = 'secondary' }) => {
  const className = cx({
    sectionTitle: true,
    [theme]: true,
  });
  return (
    <div className={className}>
      <span>{children}</span>
    </div>
  );
};

export default SectionTitle;



// WEBPACK FOOTER //
// /www/client/src/components/SectionTitle/SectionTitle.tsx